import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  collapsedSidebar = false
  openShowMenu = false
  toggleLayout = (isCollapsed: boolean) => {
    if (isCollapsed)
      this.collapsedSidebar = true
    else this.collapsedSidebar = false
  }

  openSideBar: boolean = false
  // @Input() openSideBar: boolean = false;
  // @Output() openSideBarChange: EventEmitter<boolean> = new EventEmitter();

  closeOnClick = () => {
    if (this.openSideBar) this.openSideBar = false
  }

  toggleSidebar() {
    // console.log("test")
    if(this.openSideBar) this.openSideBar = false
    else this.openSideBar = true
    // this.openSideBarChange.emit(this.openSideBar);
    // console.log(this.openSideBar)
    // console.log('menu', this.openShowMenu)
    this.openShowMenu = !this.openShowMenu
    // console.log('menu', this.openShowMenu)
  }
  
}
